<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "horse",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "估值",
                        data: "shares",
                    },
                    {
                        name: "所在地",
                        data: "a100",
                    },
                    {
                        name: "成立时间",
                        data: "dtime",
                    },
                ],
                name: '社交电商',
                cate: '零售电商',
                time: new Date().getFullYear(),
                chen: '千里马'
            },
        };
    },
    created() {
        this.$store.dispatch('getUnicorn', this.params)
    }
};
</script>

<style>
</style>